import React from "react";

import "../Star.css";

const Star6 = () => {
  return (
    <span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star"></span>
      <span className="fa fa-star"></span>
    </span>
  );
};

export default Star6;
